import { rgba } from 'polished';
import styled from 'styled-components';
import Typography from '@atoms/Typography';
import Avatar from '@atoms/Avatar';
import { devices, deviceSizes } from 'config/devices';
import { Card, Divider, Grid } from '@mui/material';

export const StyledGrid = styled(Grid)`
  && {
    display: flex;
    justify-content: center;
  }
  .css-bhp9pd-MuiPaper-root-MuiCard-root {
    border-radius: 20px;
    @media(max-width:${deviceSizes.mobileL}){
      border-radius: 5px;
    }
  }

`;

export const BodyContainer = styled(Card)`
  width:90%;
  // padding: 2.875rem 4.875rem;
  padding-bottom: 2.875rem;
  border-radius: 20px;
  margin-top: -80px;
  z-index: 2;
  .MuiSnackbar-anchorOriginTopRight {
    top: 80px;
  }
  @media ${devices.xs} {
    width:100%;
    // padding: 2.875rem 1.875rem;
    padding-top: 2.875rem;
    border-radius: 5px;
  } 
`;

export const SectionDivider = styled(Divider)`
  && {
    margin: 2rem -4.9375rem;
  }
`;

export const TopSection = styled.div`
  background-image: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-position: center;
  height: 30rem;
  margin-bottom: -10rem;
  
  @media ${devices.sm} {
    margin-top: -1rem;
  }
  @media ${devices.xs} {
    /* flex-basis: 100%; */
    margin-bottom: -6rem;

  }
  display: flex;
  justify-content: center;
  /* padding-right: 6rem; */
`;

export const Title = styled(Typography)`
  && {
    color: ${({ theme }) => theme.white};
    margin-bottom: 3.125rem;
    line-height: 1em;
  }
`;

export const OrganisationContainer = styled.div`
  background-color: ${({ theme }) => rgba(theme.common.black, 0.75)};
  height: 21.875rem;
  width: 19rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${({ theme }) => theme.white};
  
  

`;

export const OrgAvatar = styled(Avatar)`
  border: 2px solid ${({ theme }) => theme.primary.main};
  margin-bottom: 1rem;
`;
